/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { lazy, object, Schema, string } from '../schema';
import { Consent, consentSchema } from './consent';

export interface Data {
  consent: Consent;
  status: string;
  statusUpdateDateTime: string;
  creationDateTime: string;
  consentId: string;
}

export const dataSchema: Schema<Data> = object({
  consent: ['Consent', lazy(() => consentSchema)],
  status: ['Status', string()],
  statusUpdateDateTime: ['StatusUpdateDateTime', string()],
  creationDateTime: ['CreationDateTime', string()],
  consentId: ['ConsentId', string()],
});
